<template>
  <div>
    <div style="width: 20cm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print" :contentLoading="contentLoading">
      <div class="printItem" v-for="item in outStockBillVOS" :key="item.pkid">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3">
              <div :id="'qrCode' + item.billNo" align="center" />
            </td>
            <td colspan="3" style="font-weight: 700; font-size: 14px" align="center">领料单</td>
          </tr>
          <tr>
            <td>领料单号：{{ item.billNo }}</td>
            <td colspan="2">关联单号：{{ item.relBillNo }}</td>
          </tr>
          <tr>
            <td>领料类型：{{ item.outStockTypeName }}</td>
            <td colspan="2">领料时间：{{ item.requireDate }}</td>
          </tr>
          <tr>
            <td colspan="4">备注：{{ item.note }}</td>
          </tr>
          <tr>
            <td style="width: 150px">物料编号</td>
            <td>物料名称</td>
            <td>库位</td>
            <td style="width: 60px" align="center">数量</td>
          </tr>
          <tr v-for="i in item.outStockBillDetailVOS" :key="i.pkid">
            <td>{{ i.materialNo }}</td>
            <td>{{ i.materialName }}</td>
            <td>{{ i.locationName }}</td>
            <td align="center">{{ i.quantity }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      outStockBillVOS: [],
      contentLoading: false,
    };
  },

  mounted() {
    this.getData(this.$route.query.params);
  },

  methods: {
    getData(ids) {
      this.contentLoading = true;
      this.$http.get("basic", `outStockBills/getAllListByIds/${ids}`).then((resp) => {
        this.outStockBillVOS = resp.data;
        for (let item of this.outStockBillVOS) {
          this.$nextTick(() => {
            document.getElementById("qrCode" + item.billNo).innerHTML = "";
            this.bindQRCode(item.billNo);
          });
        }
        this.contentLoading = false;
      });
    },

    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 110,
        height: 110,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 20cm;
  border: 1px solid #111;
  font-size: 10px;
  margin: 10px auto;
  page-break-after: always;
  table {
    width: 100%;
    tr {
      td {
        border-bottom: 1px solid #111;
        border-right: 1px solid #111;
        padding: 10px 5px;
        min-width: 60px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
